import { FC, useState } from 'react';
import { DriveItem } from '@microsoft/microsoft-graph-types';
import { FiTrash } from 'react-icons/fi';
import strings from './onedrive.translations';
import { useDeleteItem } from '../../services/graph/hooks/onedrive';
import { ModalWithHeader } from '../modal/ModalWithHeader';
import { Button } from '../button/Button';

interface Props {
  file: DriveItem;
  onDelete: () => void;
}

export const DocumentDeleteButton: FC<Props> = ({ file, onDelete }) => {
  const deleteItem = useDeleteItem();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const onConfirm = async () => {
    setLoading(true);

    try {
      await deleteItem(file.id!);
      setModalOpen(false);
      onDelete();
    } catch {
      setError(strings.delete.errors.unknown);
    }

    setLoading(false);
  };

  return (
    <>
      <button
        type="button"
        className="w-full bg-primary-std p-2 border-t flex items-center justify-center gap-2"
        onClick={() => setModalOpen(true)}
      >
        <FiTrash className="h-5 w-5" />
        <span>{strings.common.delete}</span>
      </button>
      <ModalWithHeader open={modalOpen} onClose={() => setModalOpen(false)} title={strings.delete.title}>
        <div className="flex flex-col gap-5">
          <div>{strings.delete.message(file.name!)}</div>
          {error && <div className="text-red-500">{error}</div>}
          <div className="flex gap-2">
            <Button className="flex-1" onClick={() => setModalOpen(false)}>
              {strings.common.cancel}
            </Button>
            <Button className="flex-1" primary onClick={onConfirm} loading={loading}>
              {strings.common.delete}
            </Button>
          </div>
        </div>
      </ModalWithHeader>
    </>
  );
};
